import type { PayzheBtpSettings } from '@/types/settings';
import { settingsService } from '@/services/settings.service';
import { PAYZHE_BTP_PLAY_STORE_URL } from './config';

const ENV_LATEST =
  (import.meta.env.VITE_PAYZHE_BTP_LATEST_VERSION as string | undefined)?.trim() || '2.0.0';
const ENV_MINIMUM =
  (import.meta.env.VITE_PAYZHE_BTP_MINIMUM_VERSION as string | undefined)?.trim() || '2.0.0';

export type ResolvedPayzheBtpPolicy = {
  latestVersion: string;
  minimumVersion: string;
  playStoreUrl: string;
  apkDownloadUrl?: string;
};

export function resolvePayzheBtpPolicy(settings?: PayzheBtpSettings | null): ResolvedPayzheBtpPolicy {
  return {
    latestVersion: settings?.latestVersion?.trim() || ENV_LATEST,
    minimumVersion: settings?.minimumVersion?.trim() || ENV_MINIMUM,
    playStoreUrl: settings?.playStoreUrl?.trim() || PAYZHE_BTP_PLAY_STORE_URL,
    apkDownloadUrl: settings?.apkDownloadUrl?.trim() || undefined,
  };
}

export async function fetchPayzheBtpPolicy(): Promise<ResolvedPayzheBtpPolicy> {
  try {
    const settings = await settingsService.getSettings();
    return resolvePayzheBtpPolicy(settings.payzheBtp);
  } catch {
    return resolvePayzheBtpPolicy(null);
  }
}
